import {BoundCardModal} from '@yandex-delivery/bound-card/desktop'

import {appConfig, i18n} from 'src/shared/config'

import {useChangeCardModal} from './hooks'
import type {Props} from './types'

export function ChangeCardModal(props: Props) {
  const {card, onClose, onChange} = props
  const {fetchCardBoundContext, fetchCards, fetchBoundCard, fetchNotificationsAgreements} = useChangeCardModal(props)

  return (
    <BoundCardModal
      card={card}
      fetchBoundCard={fetchBoundCard}
      fetchCardBoundContext={fetchCardBoundContext}
      fetchCards={fetchCards}
      fetchNotificationsAgreements={fetchNotificationsAgreements}
      isCheckedOfferAgreement={false}
      notificationsAgreement={i18n(
        `order.notifications_agreement.title.${appConfig.countryCode}`,
        '<span>Cоглашаюсь на получение рекламных сообщений и обработку моих персональных данных в целях получения рекламы от ООО “Яндекс Доставка” и <a href="https://yandex.ru/legal/affiliates/" target="_blank">Группы Яндекса</a> на условиях  <a href="https://yandex.ru/legal/confidential/" target="_blank">Политики конфиденциальности</a></span>',
      )}
      offerAgreement={i18n(
        `order.offer_agreement.title.${appConfig.countryCode}`,
        'Принимаю условия <a href="https://yandex.ru/legal/delivery_tou/?lang=ru" target="_blank">оферты</a>',
      )}
      onClose={onClose}
      onSuccess={onChange}
    />
  )
}
